"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BuyN = exports.reducer = undefined;

var _buyN = require("./buy-n");

var BuyN = _interopRequireWildcard(_buyN);

var _redux = require("redux");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var reducer = exports.reducer = (0, _redux.combineReducers)({
  buyN: BuyN.reducer
});
exports.BuyN = BuyN;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9zZWxlY3RvcnMvZm9ybXMvaW5kZXguanMiXSwibmFtZXMiOlsiQnV5TiIsInJlZHVjZXIiLCJidXlOIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQ0E7O0lBQVlBLEk7O0FBQ1o7Ozs7QUFLTyxJQUFNQyw0QkFBVSw0QkFBZ0I7QUFDckNDLFFBQU1GLEtBQUtDO0FBRDBCLENBQWhCLENBQWhCO1FBR0NELEksR0FBQUEsSSIsImZpbGUiOiJpbmRleC5qcyIsInNvdXJjZXNDb250ZW50IjpbIi8vIEBmbG93XG5pbXBvcnQgKiBhcyBCdXlOIGZyb20gXCIuL2J1eS1uXCJcbmltcG9ydCB7Y29tYmluZVJlZHVjZXJzfSBmcm9tIFwicmVkdXhcIlxuXG5leHBvcnQgdHlwZSBTdGF0ZSA9IHt8XG4gICtidXlOOiBCdXlOLlN0YXRlLFxufH1cbmV4cG9ydCBjb25zdCByZWR1Y2VyID0gY29tYmluZVJlZHVjZXJzKHtcbiAgYnV5TjogQnV5Ti5yZWR1Y2VyLFxufSlcbmV4cG9ydCB7QnV5Tn1cbiJdfQ==


//////////////////
// WEBPACK FOOTER
// ../core/lib/selectors/forms/index.js
// module id = 815
// module chunks = 0